function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { DetailsFood } from "../DetailsFood/DetailsFood";
import { FoodMasthead } from "../FoodMasthead/FoodMasthead";
import { SidebarLayout } from "../../Layout/SidebarLayout/SidebarLayout";
import { FoodSocialBlock } from "../FoodSocialBlock/FoodSocialBlock";
import { IngredientsCard } from "../IngredientsCard/IngredientsCard";
import { IngredientItem } from "../IngredientItem/IngredientItem";
import { VerticalList } from "../../List/VerticalList/VerticalList";
import { Note } from "../Note/Note";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Meal = function Meal(_ref) {
  var foodMasthead = _ref.foodMasthead,
    items = _ref.items,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    note = _ref.note,
    _ref$sidebar = _ref.sidebar,
    sidebar = _ref$sidebar === void 0 ? null : _ref$sidebar,
    social = _ref.social;
  var renderMain = function renderMain() {
    var _items$items;
    return /*#__PURE__*/_jsxs(DetailsFood, {
      children: [/*#__PURE__*/_jsx(FoodSocialBlock, {
        loading: loading,
        social: social
      }), /*#__PURE__*/_jsx(IngredientsCard, {
        children: /*#__PURE__*/_jsx(VerticalList, {
          headline: items === null || items === void 0 ? void 0 : items.headline,
          loading: loading,
          zebraStripes: false,
          newspaperColumns: true,
          children: items === null || items === void 0 ? void 0 : (_items$items = items.items) === null || _items$items === void 0 ? void 0 : _items$items.map(renderIngredientList)
        })
      }), /*#__PURE__*/_jsx(SidebarLayout, {
        main: (note === null || note === void 0 ? void 0 : note.text) && /*#__PURE__*/_jsx(Note, _objectSpread({
          loading: loading
        }, note)),
        sidebar: sidebar,
        layout: "food"
      })]
    });
  };
  var renderIngredientList = function renderIngredientList(item, key) {
    if (item.ingredient.name) {
      return /*#__PURE__*/_jsx(IngredientItem, {
        ingredient: item.ingredient
      }, key);
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FoodMasthead, _objectSpread({
      loading: loading
    }, foodMasthead)), /*#__PURE__*/_jsx("div", {
      children: renderMain()
    })]
  });
};